import React from 'react';
import AreaIndicatorChart from './AreaIndicatorChart';
import DimQuantitativeChartFactory from '../../charting/dim-quant/DimQuantitativeChartFactory';
import { createDimensionalObjectivesFromRegularObjectives } from '../../objectives/helper';

const DimQuantitative_AreaIndicatorChart = ({ areaIndicator }) => {
    const getAllSamplesCount = (currentObjective) => {
        return currentObjective ? currentObjective.valuesPerDimension.reduce((total, dimension) => {
            return total + (dimension.samplesPerObjective ? dimension.samplesPerObjective.length : 0);
        }, 0) : 0;
    };

    return (
        <AreaIndicatorChart 
            areaIndicator={areaIndicator} 
            ChartFactory={DimQuantitativeChartFactory} 
            indicatorType="QUANTITATIVE_DIMENSIONAL" 
            createObjectives={createDimensionalObjectivesFromRegularObjectives}
            getAllSamplesCount={getAllSamplesCount}
        />
    );
};

export default DimQuantitative_AreaIndicatorChart;